import React, { FunctionComponent } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { MonthPicker } from '@/atoms/input'
import { convertDateToString } from '@/helpers/date'

import FieldWrapper from './field-wrapper'

export interface MonthPickerProps {
  label?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  onChange?: (date: Date) => void
  maxDate?: Date | string
  minDate?: Date | string
  hideErrorMessage?: boolean
  lastDay?: boolean
  disabled?: boolean
  tooltip?: string
}

const MonthPickerField: FunctionComponent<MonthPickerProps> = ({
  label,
  fieldProps,
  name,
  onChange,
  hideErrorMessage,
  minDate,
  maxDate,
  lastDay,
  disabled,
  tooltip,
}) => {
  const [field, meta, helpers] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error

  const handleChange = (value: Date): void => {
    onChange && onChange(value)
    helpers?.setValue(value ? convertDateToString(value) : null)
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps} hideErrorMessage={hideErrorMessage} tooltip={tooltip}>
      <MonthPicker
        id={field.name}
        hasError={hasError}
        startDate={field.value}
        onChange={handleChange}
        minDate={minDate}
        maxDate={maxDate}
        lastDay={lastDay}
        disabled={disabled}
      />
    </FieldWrapper>
  )
}

MonthPickerField.displayName = 'MonthPickerField'

export default MonthPickerField
